export default "__VITE_ASSET__NYnVyZGr__"